<template>
  <j-modal
    :title="title"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-form-item label="权限名称">
          <a-input
            :placeholder="this.$t('disp.ph.input', ['权限名称'])"
            v-decorator="['permissionName', validatorRules.permissionName]"
            :maxLength="255"
          />
        </a-form-item>

        <a-form-item :label="this.$t('disp.depart')">
          <j-input-popup
            v-model="department"
            component="SelectDepartTreeModal"
            :placeholder="this.$t('disp.ph.select', [$t('disp.depart')])"
            :params="{ companyId: '', departName: '', multiFlg: '0', departFlg: '1' }"
          ></j-input-popup>
        </a-form-item>

        <a-form-item :label="this.$t('disp.position')">
          <j-dict-select-tag
            v-model="model.positionId"
            :placeholder="this.$t('disp.ph.select', [$t('disp.position')])"
            dictCode="sys_position;name;id;del_flag = 0 order by post_rank asc,name asc"
            :require="false"
          />
        </a-form-item>

        <a-form-item :label="this.$t('disp.role')">
          <j-dict-select-tag
            v-model="model.roleId"
            :placeholder="this.$t('disp.ph.select', [$t('disp.role')])"
            dictCode="sys_role;role_name;id;del_flag = 0 order by role_name asc"
            :require="false"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { deleteAction, postAction, getAction } from '@/api/manage'

export default {
  name: 'PermissionModal',
  components: {},
  props: {},
  data() {
    return {
      title: '',
      visible: false,
      keyId: '',
      departIdOld: '',
      positionIdOld: '',
      roleIdOld: '',
      openFlag: '',
      model: {},
      department: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      loading: false,
      repeatCheckFLag: false,
      updateFLag: false,
      form: this.$form.createForm(this),
      validatorRules: {
        permissionName: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
          ],
        },
      },
      url: {
        add: '/blaze-sys/k00/k0004/PermissionManage/add',
        edit: '/blaze-sys/k00/k0004/PermissionManage/edit',
        check: '/blaze-sys/k00/k0004/PermissionManage/check',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
      this.keyId = ''
    },
    edit(record) {
      this.form.resetFields()

      if (typeof record.departId != 'undefined' && record.departId != null) {
        this.department = [{ value: record.departId, text: record.departName }]
      } else {
        this.department = []
      }

      //前画面から組織情報保存
      this.departIdOld = record.departId
      this.positionIdOld = record.positionId
      this.roleIdOld = record.roleId
      //画面openFlag設定「1:コーピー  0:コービー以外」
      if (typeof record.openFlag != 'undefined' && record.openFlag != null) {
        this.openFlag = record.openFlag
        this.keyId = ''
      } else {
        this.openFlag = ''
        this.keyId = record.permissionName
      }

      this.model = Object.assign({}, record)
      this.visible = true

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'permissionName'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      that.repeatCheckFLag = false
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          //組織ID設定
          if (that.department[0] != null) {
            that.model.departId = that.department[0].value
          } else {
            that.model.departId = null
          }

          if (
            (typeof that.model.departId != 'undefined' && that.model.departId != null) ||
            (typeof that.model.positionId != 'undefined' && that.model.positionId != null) ||
            (typeof that.model.roleId != 'undefined' && that.model.roleId != null)
          ) {
            if (that.keyId == '') {
              // DB重複データチェックが必要です
              that.repeatCheckFLag = true
            }

            if (
              that.keyId != '' &&
              (that.departIdOld != that.model.departId ||
                that.positionIdOld != that.model.positionId ||
                that.roleIdOld != that.model.roleId)
            ) {
              // DB重複データチェックが必要です
              that.repeatCheckFLag = true
            }

            if (that.repeatCheckFLag) {
              //DB重複データチェック処理を行う
              var params = {
                departId: that.model.departId,
                positionId: that.model.positionId,
                roleId: that.model.roleId,
              }

              getAction(this.url.check, params).then((res) => {
                if (!res.success) {
                  that.loading = false

                  // データ登録更新処理実行不可
                  that.updateFLag = false
                } else {
                  //権限設定情報を更新する
                  let formData = Object.assign(this.model, values)
                  let obj
                  console.log(formData)
                  if (this.keyId == '') {
                    formData.departIdOld = this.departIdOld
                    formData.positionIdOld = this.positionIdOld
                    formData.roleIdOld = this.roleIdOld
                    obj = postAction(this.url.add, formData)
                  } else {
                    var params = {
                      departId: this.model.departId,
                      positionId: this.model.positionId,
                      roleId: this.model.roleId,
                      permissionName: this.model.permissionName,
                      departIdOld: this.departIdOld,
                      positionIdOld: this.positionIdOld,
                      roleIdOld: this.roleIdOld,
                    }
                    obj = postAction(this.url.edit, params)
                  }
                  obj
                    .then((res) => {
                      if (res.success) {
                        that.$message.success(this.$t(res.message))
                        that.$emit('ok')
                      }
                    })
                    .finally(() => {
                      that.loading = false
                      that.close()
                    })
                }
              })
            } else {
              //権限設定情報を更新する
              let formData = Object.assign(this.model, values)
              let obj
              console.log(formData)
              if (this.keyId == '') {
                obj = postAction(this.url.add, formData)
              } else {
                var params = {
                  departId: this.model.departId,
                  positionId: this.model.positionId,
                  roleId: this.model.roleId,
                  permissionName: this.model.permissionName,
                  departIdOld: this.departIdOld,
                  positionIdOld: this.positionIdOld,
                  roleIdOld: this.roleIdOld,
                }
                obj = postAction(this.url.edit, params)
              }
              obj
                .then((res) => {
                  if (res.success) {
                    that.$message.success(this.$t(res.message))
                    that.$emit('ok')
                  }
                })
                .finally(() => {
                  that.loading = false
                  that.close()
                })
            }
          } else {
            this.$notification.error({
              message: this.$t('disp.error'),
              description: this.$t('msg.E_K0004002_02'),
            })
            that.loading = false
            return
          }
        } else {
          that.loading = false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style scoped></style>
